import httpClient from 'utils/httpClient'

export const list = async ({ state }: { state: string }) => {
  const { data } = await httpClient.get('/api/proposals/rfp/', {
    params: { state },
  })
  return data
}

export const retrieve = async (id: number | string) => {
  const { data } = await httpClient.get(`/api/proposals/rfp/${id}/`)
  return data
}

export const partialUpdate = async (
  id: number | string,
  payload: Partial<RequestForProposal>
) => {
  const { data } = await httpClient.patch(`/api/proposals/rfp/${id}/`, payload)
  return data
}

export const remove = async (id: number | string) => {
  const { data } = await httpClient.delete(`/api/proposals/rfp/${id}/`)
  return data
}

export const validateLanesFile = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await httpClient.post(
    '/api/proposals/rfp/file_validation/',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return data
}

export const create = async (form: FormData) => {
  const { data } = await httpClient.post('/api/proposals/rfp/', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return data
}

export const exportAwardedCarriers = async (id: number | string) => {
  const { data } = await httpClient.get(`/api/proposals/rfp_export/${id}/`)
  return data
}
